/* eslint-disable */
import { createSlice } from '@reduxjs/toolkit';

import axios from '../../utils/axios';
import { dispatch } from '../index';
import { handleError, handleSuccess } from '../../utils/apiResponseHandler.js';

const initialState = {
    error: null,
    documents: null,
    singleDocument: null,
    loading: false,
    singleDocumentLoading: false,
    saveDocumentLoading: false,

    totalPages: 0,
    totalCount: 0,
};

const slice = createSlice({
    name: 'documents',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        },

        isLoading(state, action) {
            state.loading = action.payload;
        },

        isSingleDocumentLoading(state, action) {
            state.singleDocumentLoading = action.payload;
        },

        isSaveDocumentDocumentLoading(state, action) {
            state.saveDocumentLoading = action.payload;
        },

        setDocumentsDataSuccess(state, action) {
            state.documents = action.payload?.data;
            state.totalPages = action.payload?.totalPages;
            state.totalCount = action.payload?.totalCount;
        },
        setSingleDocumentsDataSuccess(state, action) {
            state.singleDocument = action.payload;
        },

        createDocumentDataSuccess(state, action) {
            state.documents = [...(state.documents || []), ...action.payload];
        },

        //create a reducer to update the document
        updateDocumentDataSuccess(state, action) {
            const updatedDocuments = state.documents.map((document) => {
                if (document?._id === action.payload._id) {
                    return { ...document, ...action.payload };
                }
                return document;
            });
            state.documents = updatedDocuments;
        },
    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------


export function getAllDocuments({ page = 1, limit = 100, search = '' }) {
    return async () => {
        try {
            dispatch(slice.actions.isLoading(true));

            const response = await axios.get(`/compliance-document/all?search=${search}&page=${page}&limit=${limit}`);
            dispatch(slice.actions.setDocumentsDataSuccess(response.data));
        }
        catch (err) {
            handleError(err, dispatch);
        }
        finally {
            dispatch(slice.actions.isLoading(false));
        }
    }
}

export function getAllDocumentsGrouped({ }) {
    return async () => {
        try {
            dispatch(slice.actions.isLoading(true));

            const response = await axios.get(`/compliance-document/grouped`);
            dispatch(slice.actions.setDocumentsDataSuccess(response.data));
        }
        catch (err) {
            handleError(err, dispatch);
        }
        finally {
            dispatch(slice.actions.isLoading(false));
        }
    }
}

export function getSingleDocument(doc_id) {
    return async () => {
        try {
            dispatch(slice.actions.isSingleDocumentLoading(true));

            const response = await axios.get(`/compliance-document/get-one/${doc_id}`);
            dispatch(slice.actions.setSingleDocumentsDataSuccess(response.data.data));
        }
        catch (err) {
            handleError(err, dispatch);
        }
        finally {
            dispatch(slice.actions.isSingleDocumentLoading(false));
        }
    }
}

export function createDocuments(data) {
    return async () => {
        try {
            dispatch(slice.actions.isSaveDocumentDocumentLoading(true));

            const response = await axios.post(`/compliance-document/create`, data,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    }
                }
            );

            dispatch(slice.actions.createDocumentDataSuccess(response.data?.data))

            handleSuccess(response, "Document created successfully", dispatch);

            return response.data?.data;
        }
        catch (err) {
            handleError(err, dispatch);
            throw err
        }
        finally {
            dispatch(slice.actions.isSaveDocumentDocumentLoading(false));
        }
    }
}

export function updateDocuments(doc_id, data) {
    return async () => {
        try {
            dispatch(slice.actions.isSaveDocumentDocumentLoading(true));

            const response = await axios.put(`/compliance-document/update/${doc_id}`, data,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    }
                }
            );
            dispatch(slice.actions.updateDocumentDataSuccess(response.data?.data))

            handleSuccess(response, "Document updated successfully", dispatch);

            return response.data;
        }
        catch (err) {
            handleError(err, dispatch);
        }
        finally {
            dispatch(slice.actions.isSaveDocumentDocumentLoading(false));
        }
    }
}

